export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "crop_field_certification": {
            "certification_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificación"])},
            "crop_field_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo"])},
            "certification_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "certification_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número"])},
            "expiration_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de expiración"])},
            "expired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vencido"])},
            "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activo"])},
            "suspended": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suspendido"])},
            "suspended_until": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suspendido hasta"])},
            "renewal_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de renovación"])},
            "certificate_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificado"])},
            "expired_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expira en"])},
            "crop_field_cert_organization": {
              "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Observaciones"])}
            }
          }
        }
      }
    }
  })
}